import ContactUsForm from 'components/contactUsForm'
import { HomeFooter } from 'homepage/homeFooter'
import { Header } from 'homepage/homeHeader'
import React, { useEffect, useRef } from 'react'
import {  loadCaptchaEnginge } from 'react-simple-captcha'
import { toast } from 'react-toastify'



export const PartnerWithus = () =>  {
  const attchRef = useRef();

  useEffect(() => {
    loadCaptchaEnginge(6);
  }, []);



  const handleAttchFile = (e, setFieldValue) => {
    const file = e.target.files[0];
    const validTypes = ["image/jpeg", "image/png", "image/gif"];
    const maxSizeInBytes = 800 * 1024;

    if (file) {
      if (!validTypes.includes(file.type)) {
         toast.error("Only JPG,GIF,or PNG files are allowed");
        setFieldValue("attach_file", "");
        attchRef.current.value = null;
        return;
      }
      if(file.size > maxSizeInBytes) {
         toast.error("File size should not exceed 800KB.");
        setFieldValue("attach_file","");
        attchRef.current.value = null;

        return;
      }

      setFieldValue("attach_file", file);
    } else {
      setFieldValue("attach_file", "");
    }
  };
  return (
    <>
      {/* <div className='home-page'> */}
      <Header />
      <section className="network text-center pt-3">
        <div className="container network-block">
          <div className="row">
            <div className="col-md-12 mb-5">
              <div className="network-content">
                <div className="text-center mb-3 pb-1">
                  <span className="badge bg-label-primary">Partner with Zenosure</span>
                  <br />
                  {/* <span> Grow Your Business with Our Exclusive Healthcare Network</span> */}
                </div>
                {/* <p 
                  className="title-slogan px-5 mt-5" style={{textAlign: "left"}}
                  dangerouslySetInnerHTML={{__html: fetctchDetails?.partner_with_us}}
                /> */}
                <h3 className="text-center mb-1">
                  <span className="position-relative fw-bold z-1">
                    Contact Us Today
                    <img
                      src="../../assets/img/front-pages/icons/section-title-icon.png"
                      alt="laptop charging"
                      className="section-title-img position-absolute object-fit-contain bottom-0 z-n1"
                    />
                    </span> 
                  <br />
                </h3>
                <ContactUsForm/>
              </div>
            </div>
          </div>
        </div>
      </section>
      <HomeFooter />
    {/* </div> */}
    
    </>


    
  )
}
